import { Controller } from "@hotwired/stimulus"

// Polls the surrounding Turbo frame while something is running
// (data-refresh-active-value="true"). When a run finishes, the whole page is
// reloaded once so everything else on it (versions, findings) is current too.
export default class extends Controller {
  static values = { active: Boolean, url: String, interval: { type: Number, default: 4000 } }

  connect() {
    const frame = this.element.closest("turbo-frame")
    if (!frame) return

    if (this.activeValue) {
      frame.dataset.wasActive = "1"
      this.timer = setTimeout(() => (frame.src ? frame.reload() : (frame.src = this.urlValue)), this.intervalValue)
    } else if (frame.dataset.wasActive) {
      delete frame.dataset.wasActive
      window.Turbo.visit(window.location.href, { action: "replace" })
    }
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
